import { render, staticRenderFns } from "./RelationshipForm.vue?vue&type=template&id=5c39c1fa&"
import script from "./RelationshipForm.vue?vue&type=script&lang=ts&"
export * from "./RelationshipForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports